<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QtaAju/image/Cover.jpg?1708094026362" alt="This image is the cover for the book That Very Special Tree for Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">That Very Special Tree for Me
      </h1>
      <p class="bookDescription body article font2">
        <p>Dad kneeled beside me on the floor, His cheeks all red and wet. ‘You must come out my dearest, You must come out of bed.’ In this tender and therapeutic children’s tale, inspired by true events, the resilience of a young heart navigating the unpredictable currents of love and loss takes centre stage. When young Jane is awakened by her distraught father in the quiet of the night, she becomes our guide, revealing a world turned upside down by the sudden absence of a cherished loved one. Yet, even when surrounded by the shadows of grief and the silence of heartbroken parents, Jane discovers a renewed sense of purpose. With its evocative illustrations, this moving picture book is not just a story for the young but a balm for souls of all ages. Included are thoughtful conversation tools, crafted to assist caregivers, educators, and therapists in guiding children through the intricate maze of loss. Let Jane’s journey bring solace to both the heart and mind.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Angelique Le Grand, Nadine de Burlett
      </h2>
      
      <p class="authorDescription body article">ANGÉLIQUE LE GRAND is a licensed children’s therapist and mother of two adult children. She lives in the Netherlands and likes to run through misty forests, do yoga and swim in cold lakes. Due to a traumatic car accident right in front of her home, she wrote this children’s book. She searched for the best suitable illustrator to picture this emotional story but finally found her. NADINE DE BURLETT is an illustrating artist, mother of three. Her motto is to slow down in life, to create slowly and to live slowly, for time is the most valuable luxury of this day and age. Nadine makes and captures moments in her art to do just that: to slow down, observe, and simply be in the present moment.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06a8f039